import { SmlsButton } from '@smiles/smiles-ui-kit-react';
import { useMemberData } from 'pages/RedoRegisterTangie/context/MemberDataContext';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export function ContinueButton() {
  const { formType, formData, response, submitMember, submittingMember } = useMemberData();
  const { t: t2 } = useTranslation('email');

  const [isDisabled, setButtonDisabled] = useState<boolean>(true);

  const validateSimpleForm = () => {
    const {
      email,
      confirmEmail,
      cellPhone: {
        formatted: { display: phoneNumber },
      },
      streetName,
    } = formData;

    const dataToValidate = [email, confirmEmail, phoneNumber, streetName];

    const isValid = dataToValidate.every((entry) => !!entry);

    setButtonDisabled(!isValid);
  };

  const validateCompleteForm = () => {
    const {
      email,
      confirmEmail,
      terms,
      cellPhone: {
        formatted: { display: phoneNumber },
      },
      streetName,
      city,
      country,
      state,
      streetNumber,
      zipCode,
    } = formData;

    const dataToValidate = [
      email,
      confirmEmail,
      terms,
      phoneNumber,
      streetName,
      city,
      country,
      state,
      streetNumber,
      zipCode,
    ];

    const isValid = dataToValidate.every((entry) => !!entry);

    setButtonDisabled(!isValid);
  };

  useEffect(() => {
    if (formType === 'SIMPLE') {
      validateSimpleForm();
      return;
    }

    validateCompleteForm();
  }, [formData, response]);

  const handleOnClick = () => {
    submitMember();
  };

  return (
    <div data-testid="first-access-continue-button">
      <SmlsButton
        id="first-access-continue-button"
        className="continue-button"
        color="primary"
        text={t2('continue')}
        disabled={isDisabled}
        onClick={handleOnClick}
        isLoading={submittingMember}
      />
    </div>
  );
}
